var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top-menu-wrapper g-final"},[(!_setup.collected)?_vm._l((_setup.content),function(menu,idx){return _c(_setup.TopMenuItem,{key:idx,attrs:{"menu":menu},on:{"clickMenuItem":_setup.onAppMenuItemClick}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }